(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/statistics-view.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/statistics-view.js');

'use strict';

const Button = svs.ui.Button;
const {
  Fragment
} = React;
const {
  ItemsMenu: ReactItemsMenu,
  LinkItem: ReactLinkItem
} = svs.ui.ReactItemsMenu;
const {
  statisticsMenuItems
} = svs.racing.common.constants;
const {
  Overview,
  RaceHistory,
  HorseInfo
} = svs.racing_game.components.statistics;
const isMobile = svs.core.detect.formfactor.mobile();
const MENU_ITEMS = [{
  id: statisticsMenuItems.OVERVIEW,
  label: 'Överblick',
  sort: 0
}, {
  id: statisticsMenuItems.RACE_HISTORY,
  label: 'Lopp',
  sort: 1
}, {
  id: statisticsMenuItems.HORSE_INFO,
  label: 'Hästinfo',
  sort: 2
}];
const StatisticsView = _ref => {
  let {
    selectedParticipant,
    selectedMenuItem,
    toStatisticsMenuItem,
    onGoBack
  } = _ref;
  const renderMenuItems = () => MENU_ITEMS.map(item => React.createElement(Fragment, {
    key: item.id
  }, React.createElement(ReactLinkItem, {
    id: item.id,
    label: item.label,
    onClick: () => {
      if (item.id !== selectedMenuItem) {
        toStatisticsMenuItem(item.id);
      }
    },
    selected: item.id === selectedMenuItem
  })));
  const renderContent = () => React.createElement(React.Fragment, null, selectedMenuItem === statisticsMenuItems.OVERVIEW && React.createElement(Overview, {
    participantId: selectedParticipant ? selectedParticipant.participantId : undefined
  }), selectedMenuItem === statisticsMenuItems.RACE_HISTORY && React.createElement(RaceHistory, {
    participantId: selectedParticipant ? selectedParticipant.participantId : undefined
  }), selectedMenuItem === statisticsMenuItems.HORSE_INFO && React.createElement(HorseInfo, {
    participantId: selectedParticipant ? selectedParticipant.participantId : undefined
  }));
  return React.createElement("div", {
    className: "statistics-view"
  }, React.createElement("div", {
    className: "statistics-view-header"
  }, React.createElement("div", {
    className: "items-menu-racing items-menu-statistics"
  }, React.createElement(ReactItemsMenu, {
    branding: "racing"
  }, renderMenuItems()))), React.createElement("div", {
    className: "statistics-view-content-holder"
  }, React.createElement("div", {
    className: "statistics-view-content"
  }, renderContent()), isMobile && React.createElement("div", {
    className: "statistics-view-close"
  }, React.createElement("div", {
    className: "statistics-view-close-button-holder"
  }, React.createElement(Button, {
    block: true,
    onClick: () => {
      onGoBack();
    },
    size: 300,
    transparent: true
  }, "St\xE4ng")))));
};
svs.racing_game.components.statistics.StatisticsView = StatisticsView;

 })(window);